<template>
  <v-container class="iframe-container">
    <v-row>
      <v-col cols="12" id="container" ref="container">
        <v-skeleton-loader
          v-if="!loaded"
          type="card-avatar, article, actions"
        ></v-skeleton-loader>
        <iframe
          id="iframe"
          ref="iframe"
          class="iframe-bookings"
          :src="frameHRef"
          width="100%"
          height="100%"
          tabindex="0"
          allowfullscreen="true"
          role="none"
        ></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useBookingStore } from "@/features/booking/store";

const bookingStore = useBookingStore();

const frameHRef = computed(
  (): string => bookingStore.Filiale?.filiale.PublicUrl ?? "",
);

const loaded = ref(false);

onMounted(() => {
  const ef = document.getElementById("iframe") as HTMLObjectElement;
  ef.onload = () => (loaded.value = true);
});
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 180px);
  overflow-y: unset;
}

.iframe-bookings {
  border: 0px;
  height: calc(100vh - 200px);
}
</style>
